import { render, staticRenderFns } from "./equipselect.vue?vue&type=template&id=490b5a42&scoped=true"
import script from "./equipselect.vue?vue&type=script&lang=js"
export * from "./equipselect.vue?vue&type=script&lang=js"
import style0 from "./equipselect.vue?vue&type=style&index=0&id=490b5a42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490b5a42",
  null
  
)

export default component.exports